<nz-card class="round-border p-4" [nzLoading]="!loaded">
	<a [routerLink]="['/module-en-savoir-plus']">
		<nz-statistic
			[nzValue]="count | number"
			[nzTitle]="'module-en-savoir-plus_common_name' | translate"
		></nz-statistic>
	</a>
</nz-card>
